import { useForm, useFieldArray } from "react-hook-form";
import { Container, Row, Col, Button, Tab, Nav, Form } from "react-bootstrap";
import { MdAdd, MdDelete, } from "react-icons/md";
import {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
} from "../../../store/services/settingsService";
import { IoReloadCircle } from "react-icons/io5";

import { useEffect } from "react";
import toast from "react-hot-toast";

const Settings = () => {
  const { data: settingInfo, error, isLoading } = useGetSettingsQuery();
  const [updateSetting, { isLoading: isUpdating }] =
    useUpdateSettingsMutation();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      daysPerWeekOptions: [],
      weekDurationOptions: [],
      measureUnit: [],
      mealType: [],
      quantity: [],
      macroActivity: [],
      macroObjective: [],
      restrictedIngredients: [],
      restrictedRecipes: [],
      festivalCuisine: [],

      //  otherAdditionalCharges: [],
      profitMargin: [],
    },
  });
  // Manage daysPerWeekOptions array 
  const {
    fields: daysFields,
    append: appendDay,
    remove: removeDay,
  } = useFieldArray({
    control,
    name: "daysPerWeekOptions",
  });

  //Manage other Additional charge
  // const {
  //   fields: chargeFields,
  //   append: appendCharge,
  //   remove: removeCharge,
  // } = useFieldArray({
  //   control,
  //   name: "otherAdditionalCharges",
  // });

  //Manage profit Margin
  const {
    fields: profitMarginFields,
    append: appendProfitMargin,
    remove: removeProfitMargin,
  } = useFieldArray({
    control,
    name: "profitMargin",
  });

  // Manage weekDurationOptions array
  const {
    fields: weekFields,
    append: appendWeek,
    remove: removeWeek,
  } = useFieldArray({
    control,
    name: "weekDurationOptions",
  });

  const {
    fields: measureUnitFields,
    append: appendMeasureUnit,
    remove: removeMeasureUnit,
  } = useFieldArray({
    control,
    name: "measureUnit",
  });

  const {
    fields: mealTypeFields,
    append: appendMealType,
    remove: removeMealType,
  } = useFieldArray({
    control,
    name: "mealType",
  });

  const {
    fields: quantityFields,
    append: appendQuantity,
    remove: removeQuantity,
  } = useFieldArray({
    control,
    name: "quantity",
  });

  const {
    fields: macroActivityFields,
    append: appendMacroActivity,
    remove: removeMacroActivity,
  } = useFieldArray({
    control,
    name: "macroActivity",
  });

  const {
    fields: macroObjectiveFields,
    append: appendMacroObjective,
    remove: removeMacroObjective,
  } = useFieldArray({
    control,
    name: "macroObjective",
  });

  const {
    fields: cuisinesFields,
    append: appendCuisines,
    remove: removeCuisines,
  } = useFieldArray({
    control,
    name: "cuisines",
  });

  // const {
  //   fields: aiPreferredCuisinesFields,
  //   append: appendAiPreferredCuisines,
  //   remove: removeAiPreferredCuisines,
  // } = useFieldArray({
  //   control,
  //   name: "festivalCuisine.preferredCuisines",
  // });

  const {
    fields: festiveCuisinesFields,
    append: appendFestiveCuisines,
    remove: removeFestiveCuisines,
  } = useFieldArray({
    control,
    name: "festivalCuisine",
  });

  const {
    fields: openWeekDaysFields,
    append: appendOpenWeekDays,
    remove: removeOpenWeekDays,
  } = useFieldArray({
    control,
    // name: "openWeekDays",
    // name: "cutOffStartDay",
    name: "businessDays",
  });

  const {
    fields: restrictedIngredientsFields,
    append: appendRestrictedIngredients,
    remove: removeRestrictedIngredients,
  } = useFieldArray({
    control,
    name: "restrictedIngredients",
  });

  const {
    fields: restrictedRecipesFields,
    append: appendRestrictedRecipes,
    remove: removeRestrictedRecipes,
  } = useFieldArray({
    control,
    name: "restrictedRecipes",
  });

  const appendAiPreferredCuisines = (index) => {
    // Get the current values of festivalCuisine
    const currentFestivalCuisine = getValues("festivalCuisine");

    // Add an empty string to preferredCuisines for the target index
    currentFestivalCuisine[index].preferredCuisines.push("");

    // Update the form state
    setValue("festivalCuisine", [...currentFestivalCuisine]);
  };

  const removeAiPreferredCuisines = (index, cuisineIndex) => {
    // Get the current values of festivalCuisine
    const currentFestivalCuisine = getValues("festivalCuisine");

    // Remove the cuisine at cuisineIndex from preferredCuisines
    currentFestivalCuisine[index].preferredCuisines.splice(cuisineIndex, 1);

    // Update the form state
    setValue("festivalCuisine", [...currentFestivalCuisine]);
  };
  // const onSubmit = async (data) => {
  //   try {

  //     await updateSetting({
  //       settingsId: settingInfo?.data?._id,
  //       updatedData: { ...data, swapMargin: Number(data.swapMargin) },
  //     });
  //     return toast.success(`Setting updated successfully`);
  //   } catch (error) {
  //     console.error("Failed to delete the meal:", error); // Handle error
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      await updateSetting({
        settingsId: settingInfo?.data?._id,
        updatedData: {
          ...data,
          swapMargin: Number(data.swapMargin),
          referralDiscountForReferrer: Number(data.referralDiscountForReferrer),
          referralDiscountForReferee: Number(data.referralDiscountForReferee),
        },
      });
      return toast.success("Setting updated successfully");
    } catch (error) {
      console.error("Failed to update the setting:", error); // Handle error
    }
  };
  

  console.log("settingInfo ===>", settingInfo);

  useEffect(() => {
    if (settingInfo) {
      setValue("daysPerWeekOptions", settingInfo?.data?.daysPerWeekOptions);
      // setValue("otherAdditionalCharges", settingInfo?.data?.otherAdditionalCharges);
      setValue("profitMargin", settingInfo?.data?.profitMargin);
      setValue("weekDurationOptions", settingInfo?.data?.weekDurationOptions);
      setValue("measureUnit", settingInfo?.data?.measureUnit);
      setValue("mealType", settingInfo?.data?.mealType);
      setValue("quantity", settingInfo?.data?.quantity);
      setValue("macroActivity", settingInfo?.data?.macroActivity);
      setValue("macroObjective", settingInfo?.data?.macroObjective);
      setValue("cuisines", settingInfo?.data?.cuisines);
      setValue("openDayName", settingInfo?.data?.openDayName);
      setValue("cutOffTime", settingInfo?.data?.cutOffTime);
      // setValue("businessDaysCount", settingInfo?.data?.businessDaysCount);
      // setValue("openWeekDays", settingInfo?.data?.openWeekDays);
      setValue("businessDays", settingInfo?.data?.businessDays);
      setValue("cutOffStartDay", settingInfo?.data?.cutOffStartDay);
      setValue(
        "restrictedIngredients",
        settingInfo?.data?.restrictedIngredients
      );
      setValue("restrictedRecipes", settingInfo?.data?.restrictedRecipes);
      setValue("taxAndCharges", settingInfo?.data?.taxAndCharges);
      setValue("swapMargin", settingInfo?.data?.swapMargin);
      setValue("referralDiscountForReferrer", settingInfo?.data?.referralDiscountForReferrer);
      setValue("referralDiscountForReferee", settingInfo?.data?.referralDiscountForReferee);
      setValue("dynamicMacros", settingInfo?.data?.dynamicMacros);
      setValue("macroPageSetting", settingInfo?.data?.macroPageSetting);
      setValue("festivalCuisine", settingInfo?.data?.festivalCuisine);
      setValue("emailManage", settingInfo?.data?.emailManage);
      // setValue("aiPreferredCuisines", settingInfo?.data?.aiPreferredCuisines);
    }
  }, [settingInfo]);

  console.log(
    "festiveCuisinesFields  ==================>",
    festiveCuisinesFields
  );

  useEffect(() => {
    let toastId;

    if (isUpdating) {
      // Show loading toast and save the IDs
      toastId = toast.loading("Updating...");
    } else if (toastId) {
      // Dismiss the loading toast when isUpdating is false.
      toast.dismiss(toastId);
    }

    return () => {
      // Cleanup: Ensure toast is dismissed if the component unmounts
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [isUpdating]);

  const mealTypeOptions = settingInfo?.data?.mealType?.filter(item => item.status === "active") || [];

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              Settings
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}

          {!isLoading && (
            <Col lg="12" md="12" sm="12" className="my-2">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                  style={{ background: "#EEEEEE" }}
                >
                  <Row className="">
                    <Col lg="12">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="days"
                      >
                        <Nav
                          variant="pills"
                          className="inline-flex pillsTab gap-10 pb-2"
                          style={{
                            // background: "#033E8A",
                            maxWidth: "max-content",
                          }}
                        >
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="days"
                            >
                              Days & Weeks
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="Measure"
                            >
                              Unit & Quantity
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="Meal"
                            >
                              Meal & Cuisine Types
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="Restricted-Ingredients"
                            >
                              Restricted Ingredients
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="tax"
                            >
                              Tax & Charges
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="business-days"
                            >
                              Business Days
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="dynamic-macros"
                            >
                              Dynamic Macros
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="calculation-macros"
                            >
                              Calculation Macros
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="macros-page-setting"
                            >
                              Macros Page Setting
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link
                              className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                              eventKey="email-manage"
                            >
                              Manage Email
                            </Nav.Link>
                          </Nav.Item>
                        </Nav>

                        <Tab.Content className="pt-3">
                          <Tab.Pane eventKey="days">
                            <Row>
                              {/* Days Per Week Options */}
                              <Col md={12} className="my-2">
                                <h5>Days Per Week Options</h5>
                                {daysFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label
                                        htmlFor={`daysPerWeekOptions.${index}.label`}
                                      >
                                        {/* Label */} Days per week
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Enter days per week"
                                        {...register(
                                          `daysPerWeekOptions.${index}.label`,
                                          {
                                            required: "Please enter days per week",
                                          }
                                        )}
                                      />
                                      {errors?.daysPerWeekOptions?.[index]?.label && (
                                        <span className="text-danger">
                                          {errors.daysPerWeekOptions?.[index]?.label.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`daysPerWeekOptions.${index}.value`}
                                      >
                                        {/* Value */} Days
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control small-input"
                                        placeholder="Enter Value"
                                        {...register(
                                          `daysPerWeekOptions.${index}.value`,
                                          {
                                            required: "Please enter days",
                                            min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.daysPerWeekOptions?.[index]?.value && (
                                        <span className="text-danger">
                                          {errors.daysPerWeekOptions?.[index]?.value.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeDay(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  onClick={() =>
                                    appendDay({ label: "", value: "" })
                                  }
                                >
                                  <MdAdd /> Add day
                                </Button>
                              </Col>

                              {/* Week Duration Options */}
                              <Col md={12} className="my-2">
                                <h5>Week Duration Options</h5>
                                {weekFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label
                                        htmlFor={`weekDurationOptions.${index}.label`}
                                      >
                                        {/* Label */} Weeks per month
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Enter week per month"
                                        {...register(
                                          `weekDurationOptions.${index}.label`,
                                          {
                                            required: "Please enter weeks per month",
                                          }
                                        )}
                                      />
                                      {errors?.weekDurationOptions?.[index]?.label && (
                                        <span className="text-danger">
                                          {errors.weekDurationOptions?.[index]?.label.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`weekDurationOptions.${index}.value`}
                                      >
                                        {/* Value */} Weeks
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control small-input"
                                        placeholder="Enter value"
                                        {...register(
                                          `weekDurationOptions.${index}.value`,
                                          {
                                            required: "Please enter week",
                                            min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.weekDurationOptions?.[index]?.value && (
                                        <span className="text-danger">
                                          {errors.weekDurationOptions?.[index]?.value.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`weekDurationOptions.${index}.discount`}
                                      >
                                        {/* Value */} Discount (%)
                                      </label>
                                      <input
                                        type="number"
                                        step="0.001"
                                        className="form-control small-input"
                                        placeholder="Enter discount"
                                        {...register(
                                          `weekDurationOptions.${index}.discount`,
                                          {
                                            required: "Please enter discount",
                                            //min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.weekDurationOptions?.[index]?.discount && (
                                        <span className="text-danger">
                                          {errors.weekDurationOptions?.[index]?.discount.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label htmlFor={`weekDurationOptions.${index}.enabled`}>Enabled</label>
                                      <Form.Check
                                        style={{ marginTop: "12px" }}
                                        type="switch"
                                        id={`custom-switch-${index}`}
                                        {...register(
                                          `weekDurationOptions.${index}.enabled`
                                        )}
                                        className={`${errors?.weekDurationOptions?.[index]
                                          ?.enabled
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                      />
                                      {errors?.weekDurationOptions?.[index]
                                        ?.enabled && (
                                          <span className="text-danger ms-2">
                                            {
                                              errors?.weekDurationOptions?.[index]
                                                ?.enabled.message
                                            }
                                          </span>
                                        )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeWeek(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  onClick={() =>
                                    appendWeek({ label: "", value: "" })
                                  }
                                >
                                  <MdAdd /> Add week
                                </Button>
                              </Col>
                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="Measure">
                            <Row>
                              {/* Measure Unit */}
                              <Col md={4} className="my-2">
                                <h5>Measure Units</h5>
                                {measureUnitFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label
                                        htmlFor={`measureUnit.${index}.unit`}
                                      >
                                        Unit
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Unit"
                                        {...register(
                                          `measureUnit.${index}.unit`,
                                          {
                                            required: "Please enter unit",
                                          }
                                        )}
                                      />
                                      {errors?.measureUnit?.[index]?.unit && (
                                        <span className="text-danger">
                                          {errors.measureUnit?.[index]?.unit.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeMeasureUnit(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button

                                  onClick={() =>
                                    appendMeasureUnit({ unit: "" })
                                  }
                                >
                                  <MdAdd /> Unit
                                </Button>
                              </Col>

                              {/* Quantity */}
                              <Col md={4} className="my-2">
                                <h5>Quantity's</h5>
                                {quantityFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label htmlFor={`quantity.${index}`}>
                                        Quantity
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Quantity"
                                        {...register(`quantity.${index}`, {
                                          required: "Please enter quantity",
                                        })}
                                      />
                                      {errors?.quantity?.[index] && (
                                        <span className="text-danger">
                                          {errors.quantity?.[index]?.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeQuantity(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button onClick={() => appendQuantity("")}>
                                  <MdAdd /> Quantity
                                </Button>
                              </Col>

                              {/* Bussiness day count */}
                              <Col md={4} className="my-2">
                                <h5>Bussiness day count</h5>
                                <div className="d-flex gap-3 my-2">
                                  <div>
                                    <label htmlFor="swapMargin">Bussiness day count</label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter bussiness day count"
                                      {...register(`swapMargin`, {
                                        required: "Please enter bussiness day count",
                                      })}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="Meal">
                            <Row>
                              {/* Meal Type */}
                              <Col md={4} className="my-2">
                                <h5>Meal Types</h5>
                                {mealTypeFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label htmlFor={`mealType.${index}.type`}>
                                        Type
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Type"
                                        {...register(`mealType.${index}.type`, {
                                          required: "Type is required",
                                        })}
                                      />
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeMealType(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  onClick={() => appendMealType({ type: "" })}
                                >
                                  <MdAdd /> Type
                                </Button>
                              </Col>

                              {/* Cuisines */}
                              <Col md={4} className="my-2">
                                <h5>Cuisines</h5>
                                {cuisinesFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label htmlFor={`cuisines.${index}`}>
                                        Cuisines
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control small-input"
                                        placeholder="Cuisines"
                                        {...register(`cuisines.${index}`, {
                                          required: "Cuisines are required",
                                        })}
                                      />
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeCuisines(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button onClick={() => appendCuisines("")}>
                                  <MdAdd /> Cuisines
                                </Button>
                              </Col>

                              {/* Cuisines */}
                              <Col md={4} className="my-2">
                                <h5>Festive Cuisines Recommendation</h5>

                                {festiveCuisinesFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2 flex-wrap"
                                  >
                                    <div className="py-2">
                                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                                        Festival
                                      </label>
                                      <input
                                        type="text"
                                        {...register(
                                          `festivalCuisine.${index}.festival`,
                                          {
                                            required:
                                              "festivalCuisine title is required",
                                          }
                                        )}
                                        className={`form-control ${errors?.festivalCuisine?.[index]
                                          ?.festival
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                      />
                                      {errors?.festivalCuisine?.[index]
                                        ?.festival && (
                                          <span className="text-danger">
                                            {
                                              errors?.festivalCuisine?.[index]
                                                ?.festival.message
                                            }
                                          </span>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center mt-2">
                                      <label className="me-2">Enabled</label>
                                      <Form.Check
                                        type="switch"
                                        id={`custom-switch-${index}`}
                                        {...register(
                                          `festivalCuisine.${index}.enabled`
                                        )}
                                        className={`${errors?.festivalCuisine?.[index]
                                          ?.enabled
                                          ? "is-invalid"
                                          : ""
                                          }`}
                                      />
                                      {errors?.festivalCuisine?.[index]
                                        ?.enabled && (
                                          <span className="text-danger ms-2">
                                            {
                                              errors?.festivalCuisine?.[index]
                                                ?.enabled.message
                                            }
                                          </span>
                                        )}
                                    </div>

                                    <Button
                                      type="button"
                                      variant="danger"
                                      onClick={() =>
                                        removeFestiveCuisines(index)
                                      }
                                      className="mt-2"
                                    >
                                      <MdDelete />
                                    </Button>
                                    <div className="my-2">
                                      {item?.preferredCuisines?.map(
                                        (item, childIndex) => (
                                          <div
                                            key={item.id}
                                            className="d-flex gap-3 my-2"
                                          >
                                            <div>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Festive Cuisines Recommendation"
                                                {...register(
                                                  `festivalCuisine.${index}.preferredCuisines.${childIndex}`,
                                                  {
                                                    required:
                                                      "Preferred cuisines are required",
                                                  }
                                                )}
                                              />
                                            </div>
                                            <Button
                                              variant="danger"
                                              onClick={() =>
                                                removeAiPreferredCuisines(
                                                  index,
                                                  childIndex
                                                )
                                              }
                                            >
                                              <MdDelete />
                                            </Button>
                                          </div>
                                        )
                                      )}
                                    </div>

                                    <Button
                                      onClick={() =>
                                        appendAiPreferredCuisines(index)
                                      }
                                    >
                                      <MdAdd /> PreferredCuisines
                                    </Button>
                                  </div>
                                ))}
                                <Col lg="12" className="text-right mt-3">
                                  <Button
                                    type="button"
                                    color="primary"
                                    onClick={() =>
                                      appendFestiveCuisines({
                                        enabled: true,
                                        festival: "",
                                        preferredCuisines: [""],
                                      })
                                    }
                                  >
                                    <MdAdd />
                                    Festival cuisines
                                  </Button>
                                </Col>

                                {/* {aiPreferredCuisinesFields.map(
                                  (item, index) => (
                                    <div
                                      key={item.id}
                                      className="d-flex gap-3 my-2"
                                    >
                                      <div>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Festive Cuisines Recommendation"
                                          {...register(
                                            `aiPreferredCuisines.${index}`,
                                            {
                                              required:
                                                "Ai PreferredCuisines are required",
                                            }
                                          )}
                                        />
                                      </div>
                                      <Button
                                        variant="danger"
                                        onClick={() =>
                                          removeAiPreferredCuisines(index)
                                        }
                                      >
                                        <MdDelete />
                                      </Button>
                                    </div>
                                  )
                                )}
                                <Button
                                  onClick={() => appendAiPreferredCuisines("")}
                                >
                                  <MdAdd /> aiPreferredCuisines
                                </Button> */}
                              </Col>
                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="Restricted-Ingredients">
                            <Row>
                              <Col md={6} className="my-2">
                                <h5>Restricted Ingredients</h5>
                                {restrictedIngredientsFields.map(
                                  (item, index) => (
                                    <div
                                      key={item.id}
                                      className="d-flex gap-3 my-2"
                                    >
                                      <div>
                                        <label
                                          htmlFor={`restrictedIngredients.${index}`}
                                        >
                                          Restricted Ingredient
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control small-input"
                                          placeholder="Enter restricted ingredient"
                                          {...register(
                                            `restrictedIngredients.${index}`,
                                            {
                                              required:
                                                "Please enter restricted ingredient",
                                            }
                                          )}
                                        />
                                        {errors?.restrictedIngredients?.[index] && (
                                          <span className="text-danger">
                                            {errors.restrictedIngredients?.[index]?.message}
                                          </span>
                                        )}
                                      </div>
                                      <Button
                                        style={{ height: "40px", marginTop: "28px" }}
                                        variant="danger"
                                        onClick={() =>
                                          removeRestrictedIngredients(index)
                                        }
                                      >
                                        <MdDelete />
                                      </Button>
                                    </div>
                                  )
                                )}
                                <Button
                                  onClick={() =>
                                    appendRestrictedIngredients("")
                                  }
                                >
                                  <MdAdd /> Restricted Ingredients
                                </Button>
                              </Col>

                              <Col md={6} className="my-2">
                                <h5>Restricted Recipes</h5>
                                {restrictedRecipesFields.map(
                                  (item, index) => (
                                    <div
                                      key={item.id}
                                      className="d-flex gap-3 my-2"
                                    >
                                      <div>
                                        <label
                                          htmlFor={`restrictedRecipes.${index}`}
                                        >
                                          Restricted Recipes
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control small-input"
                                          placeholder="Enter restricted recipe"
                                          {...register(
                                            `restrictedRecipes.${index}`,
                                            {
                                              required:
                                                "Please enter restricted recipe",
                                            }
                                          )}
                                        />
                                        {errors?.restrictedRecipes?.[index] && (
                                          <span className="text-danger">
                                            {errors.restrictedRecipes?.[index]?.message}
                                          </span>
                                        )}
                                      </div>
                                      <Button
                                        style={{ height: "40px", marginTop: "28px" }}
                                        variant="danger"
                                        onClick={() =>
                                          removeRestrictedRecipes(index)
                                        }
                                      >
                                        <MdDelete />
                                      </Button>
                                    </div>
                                  )
                                )}
                                <Button
                                  onClick={() =>
                                    appendRestrictedRecipes("")
                                  }
                                >
                                  <MdAdd /> Restricted Recipes
                                </Button>
                              </Col>

                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="tax">
                            <Row>
                              <Col md={12} className="my-2">
                                <h5>Tax And Charges</h5>
                                {/* <div className="d-flex gap-3 my-2">
                                  <label htmlFor="taxAndCharges.vat">VAT (%)</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="VAT"
                                    {...register(`taxAndCharges.vat`, {
                                      required: "VAT is required",
                                    })}
                                  />
                                </div> */}
                                <div className="d-flex gap-3 my-2">
                                  <div
                                  //className="d-flex gap-3 my-2"
                                  >
                                    <label htmlFor="taxAndCharges.boxPrice">
                                      Cooler Bag
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter Cooler Bag"
                                      {...register(`taxAndCharges.boxPrice`, {
                                        required: "Cooler Bag is required",
                                      })}
                                    />
                                  </div>
                                  <div
                                  // className="d-flex gap-3 my-2"
                                  >
                                    <label htmlFor="taxAndCharges.deliveryFees">
                                      Delivery Fees
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter Delivery Fees"
                                      {...register(`taxAndCharges.deliveryFees`, {
                                        required: "Delivery Fees is required",
                                      })}
                                    />
                                  </div>
                                  <div
                                  // className="d-flex gap-3 my-2"
                                  >
                                    <label htmlFor="taxAndCharges.advanceMacroFees">
                                      Advance Macro Fees
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter Advance Macro Fees"
                                      {...register(
                                        `taxAndCharges.advanceMacroFees`,
                                        {
                                          required:
                                            "Advance Macro Fees is required",
                                        }
                                      )}
                                    />
                                  </div>
                                </div>
                                {/* <div className="d-flex gap-3 my-2">
                                  <label htmlFor="taxAndCharges.profitMarginPercentage">
                                    Profit Margin Percentage
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Profit Margin Percentage"
                                    {...register(
                                      `taxAndCharges.profitMarginPercentage`,
                                      {
                                        required:
                                          "Profit Margin Percentage is required",
                                      }
                                    )}
                                  />
                                </div> */}
                              </Col>

                              <Col md={12} className="my-2">
                                <h5>Referral Discount</h5>

                                <div className="d-flex gap-3 my-2">
                                  <div>
                                    <label htmlFor="swapMargin">Referral Discount For Referrer (%)</label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter Referral Discount For Referrer"
                                      {...register(`referralDiscountForReferrer`, {
                                        required: "Please enter Referral Discount For Referrer",
                                      })}
                                    />
                                  </div>



                                  <div>
                                    <label htmlFor="swapMargin">Referral Discount For Referee (%)</label>
                                    <input
                                      type="number"
                                      className="form-control small-input"
                                      placeholder="Enter Referral Discount For Referee"
                                      {...register(`referralDiscountForReferee`, {
                                        required: "Please enter Referral Discount For Referee",
                                      })}
                                    />
                                  </div>
                                </div>
                              </Col>

                              {/* <Col md={6} className="my-2">
                                <h5>Other Additional Charges</h5>
                                {chargeFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label
                                        htmlFor={`otherAdditionalCharges.${index}.label`}
                                      >
                                        Label
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Label"
                                        {...register(
                                          `otherAdditionalCharges.${index}.label`,
                                          {
                                            required: "please enter label",
                                          }
                                        )}
                                      />
                                      {errors?.otherAdditionalCharges?.[index]?.label && (
                                        <span className="text-danger">
                                          {errors.otherAdditionalCharges?.[index]?.label.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`otherAdditionalCharges.${index}.value`}
                                      >
                                        Value
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Value"
                                        {...register(
                                          `otherAdditionalCharges.${index}.value`,
                                          {
                                            required: "Please enter value",
                                            min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.otherAdditionalCharges?.[index]?.value && (
                                        <span className="text-danger">
                                          {errors.otherAdditionalCharges?.[index]?.value.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeCharge(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  onClick={() =>
                                    appendCharge({ label: "", value: "" })
                                  }
                                >
                                  <MdAdd /> Add
                                </Button>
                              </Col> */}

                              <Col md={12} className="my-2">
                                <h5>Selling Price</h5>
                                {profitMarginFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >


                                    {/* Dropdown for Meal Type */}
                                    <div>
                                      <label htmlFor={`profitMargin.${index}.mealType`}>Meal Type</label>
                                      <select
                                        className="form-control"
                                        {...register(`profitMargin.${index}.mealType`, {
                                          required: "Please select a meal type",
                                        })}
                                      >
                                        <option value="">Select Meal Type</option>
                                        <option value="Breakfast">Breakfast</option>
                                        <option value="Lunch/Dinner">Lunch/Dinner</option>
                                        {/* {mealTypeOptions.map((meal) => (
                                          <option key={meal._id} value={meal.type}>
                                            {meal.type}
                                          </option>
                                        ))} */}
                                      </select>
                                      {errors?.profitMargin?.[index]?.mealType && (
                                        <span className="text-danger">
                                          {errors.profitMargin[index].mealType.message}
                                        </span>
                                      )}
                                    </div>


                                    <div>
                                      <label
                                        htmlFor={`profitMargin.${index}.minValue`}
                                      >
                                        Minimum Cost (AED)
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control small-input"
                                        placeholder="Enter min value"
                                        {...register(
                                          `profitMargin.${index}.minValue`,
                                          {
                                            required: "please enter minimum cost",
                                          }
                                        )}
                                      />
                                      {errors?.profitMargin?.[index]?.minValue && (
                                        <span className="text-danger">
                                          {errors.profitMargin?.[index]?.minValue.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`profitMargin.${index}.maxValue`}
                                      >
                                        Maximum Cost (AED)
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control small-input"
                                        placeholder="Enter max value"
                                        {...register(
                                          `profitMargin.${index}.maxValue`,
                                          {
                                            required: "Please enter maximum cost",
                                            min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.profitMargin?.[index]?.maxValue && (
                                        <span className="text-danger">
                                          {errors.profitMargin?.[index]?.maxValue.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`profitMargin.${index}.sellingPrice`}
                                      >
                                        Selling Price
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control small-input"
                                        placeholder="Enter profit margin percentage"
                                        {...register(
                                          `profitMargin.${index}.sellingPrice`,
                                          {
                                            required: "please enter selling price",
                                          }
                                        )}
                                      />
                                      {errors?.profitMargin?.[index]?.sellingPrice && (
                                        <span className="text-danger">
                                          {errors.profitMargin?.[index]?.sellingPrice.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`profitMargin.${index}.printingCharge`}
                                      >
                                        Printing Charge
                                      </label>
                                      <input
                                        type="number"
                                        step="0.001"
                                        className="form-control small-input"
                                        placeholder="Enter printing charge"
                                        {...register(
                                          `profitMargin.${index}.printingCharge`,
                                          {
                                            required: "please enter printing charge",
                                          }
                                        )}
                                      />
                                      {errors?.profitMargin?.[index]?.printingCharge && (
                                        <span className="text-danger">
                                          {errors.profitMargin?.[index]?.printingCharge.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeProfitMargin(index)}
                                    >
                                      <MdDelete />
                                      {/* <IoReloadCircle /> */}
                                    </Button>
                                  </div>
                                ))}
                                <Button
                                  style={{ marginTop: "10px" }}
                                  onClick={() =>
                                    appendProfitMargin({ mealType: "", minValue: "", maxValue: "", sellingPrice: "", })
                                  }
                                >
                                  <MdAdd /> Selling price
                                </Button>
                              </Col>


                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="business-days">

                            {/* <Col md={4} className="my-2">
                              <h5>Business Days Count</h5>
                              <div className="d-flex gap-3 my-2">
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Business Days Count"
                                  {...register(`businessDaysCount`, {
                                    required: "Business Days Count is required",
                                  })}
                                />
                              </div>
                            </Col>
                            <Col md={4} className="my-2">
                              <h5>Open day name</h5>
                              <div className="d-flex gap-3 my-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Open day name"
                                  {...register(`openDayName`, {
                                    required: "Open day name Count is required",
                                  })}
                                />
                              </div>
                            </Col>
                            <Col md={4} className="my-2">
                              <h5>Cut off time</h5>
                              <div className="d-flex gap-3 my-2">
                                <input
                                  type="time"
                                  className="form-control"
                                  placeholder="Business Days Count"
                                  {...register(`cutOffTime`, {
                                    required: "Cut off time Count is required",
                                  })}
                                />
                              </div>
                            </Col> */}

                            <Col md={12} className="my-2">
                              <h5>Bussiness days</h5>
                              {openWeekDaysFields.map((item, index) => (
                                <div
                                  key={item.id}
                                  //className="d-flex gap-3 my-2"
                                  className="my-2"
                                >

                                  <div className="d-flex gap-3">
                                    <div className="flex-grow-1">
                                      <label>Cut Off Days</label>
                                    </div>
                                    <div className="flex-grow-1">
                                      <label>Cut Off Time</label>
                                    </div>
                                    <div className="flex-grow-1">
                                      <label style={{ marginRight: "55px" }}>Delivery Days</label>
                                    </div>
                                  </div>

                                  <div className="d-flex gap-3">
                                    <select
                                      className="form-control"
                                      {...register(`businessDays.${index}.cutOffDays.label`, {
                                        required: "Cut off start day label is required",
                                        onChange: (e) => {
                                          const dayValueMapping = {
                                            Sunday: 0,
                                            Monday: 1,
                                            Tuesday: 2,
                                            Wednesday: 3,
                                            Thursday: 4,
                                            Friday: 5,
                                            Saturday: 6,
                                          };
                                          // Update the corresponding value field when the label changes
                                          const selectedDay = e.target.value;
                                          // setValue(
                                          //   `businessDays.${index}.cutOffDays.value`,
                                          //   dayValueMapping[selectedDay] || 0
                                          // );
                                          setValue(
                                            `businessDays.${index}.cutOffDays`,
                                            { label: selectedDay, value: dayValueMapping[selectedDay] || 0 }
                                          );
                                        },
                                      })}
                                    >
                                      <option value="">Select a cut off days</option>
                                      <option value="Sunday">Sunday</option>
                                      <option value="Monday">Monday</option>
                                      <option value="Tuesday">Tuesday</option>
                                      <option value="Wednesday">Wednesday</option>
                                      <option value="Thursday">Thursday</option>
                                      <option value="Friday">Friday</option>
                                      <option value="Saturday">Saturday</option>
                                    </select>

                                    <input
                                      type="time"
                                      className="form-control "
                                      placeholder="Cut off time"
                                      {...register(
                                        `businessDays.${index}.cutOffTime`,
                                        {
                                          required: "Cut off time is required",
                                        }
                                      )}
                                    />

                                    <select
                                      className="form-control"
                                      {...register(`businessDays.${index}.deliveryDay.label`, {
                                        required: "Delivery day label is required",
                                        onChange: (e) => {
                                          const dayValueMapping = {
                                            Sunday: 0,
                                            Monday: 1,
                                            Tuesday: 2,
                                            Wednesday: 3,
                                            Thursday: 4,
                                            Friday: 5,
                                            Saturday: 6,
                                          };
                                          // Update the corresponding value field when the label changes
                                          const selectedDay = e.target.value;
                                          // setValue(
                                          //   `businessDays.${index}.deliveryDay.value`,
                                          //   dayValueMapping[selectedDay] || 0
                                          // );
                                          setValue(
                                            `businessDays.${index}.deliveryDay`,
                                            { label: selectedDay, value: dayValueMapping[selectedDay] || 0 }
                                          );
                                        },
                                      })}
                                    >
                                      <option value="">Select a delivery day</option>
                                      <option value="Sunday">Sunday</option>
                                      <option value="Monday">Monday</option>
                                      <option value="Tuesday">Tuesday</option>
                                      <option value="Wednesday">Wednesday</option>
                                      <option value="Thursday">Thursday</option>
                                      <option value="Friday">Friday</option>
                                      <option value="Saturday">Saturday</option>
                                    </select>

                                    {/* <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Value"
                                    {...register(
                                      `cutOffStartDay.${index}.value`,
                                      {
                                        required: "Cut off start day value is required",
                                      }
                                    )}
                                   />

                                    <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name"
                                    {...register(
                                      `openWeekDays.${index}.dayName`,
                                      {
                                        required: "name is required",
                                      }
                                    )}
                                   />
                                    <input
                                    type="time"
                                    className="form-control"
                                    placeholder="Open Time"
                                    {...register(
                                      `openWeekDays.${index}.openAt`,
                                      {
                                        required: "Open Time is required",
                                      }
                                    )}
                                    />
                                    <input
                                    type="time"
                                    className="form-control"
                                    placeholder="Closed Time"
                                    {...register(
                                      `openWeekDays.${index}.closedAt`,
                                      {
                                        required: "Closed Time is required",
                                      }
                                    )}
                                    />
                                    <select
                                    className="form-control"
                                    {...register(
                                      `openWeekDays.${index}.status`,
                                      {
                                        required: "Status is required",
                                      }
                                    )}
                                  >
                                    <option value="">Select status</option>
                                    <option value="active">Open</option>
                                    <option value="inactive">Close</option>
                                    </select> */}

                                    <Button
                                      variant="danger"
                                      onClick={() => removeOpenWeekDays(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                </div>
                              ))}
                              {openWeekDaysFields?.length < 7 && (
                                <Button
                                  onClick={() =>
                                    appendOpenWeekDays({
                                      // dayName: "",
                                      // openAt: "",
                                      // closedAt: "",
                                      // status: "",

                                      // label: "",
                                      // value: "",
                                      // cutOffTime: "",
                                      cutOffDays: { label: "", value: "" },
                                      deliveryDay: { label: "", value: "" },
                                      cutOffTime: "",
                                    })
                                  }
                                >
                                  <MdAdd /> Day
                                </Button>
                              )}
                            </Col>

                          </Tab.Pane>

                          <Tab.Pane eventKey="dynamic-macros">
                            <Row>
                              <Col md={12} className="my-2">
                                <h5>Advance</h5>
                                <div className="d-flex gap-3 my-2">
                                  <div
                                  // className="d-flex gap-3 my-2"
                                  >
                                    <label>Title</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter advance title"
                                      {...register(`dynamicMacros.advanced.title`, {
                                        required: "Advance title is required",
                                      })}
                                    />
                                  </div>

                                  <div
                                  //className="d-flex gap-3 my-2"
                                  >
                                    <label>price</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter advance price"
                                      {...register(`dynamicMacros.advanced.price`, {
                                        required: "Advance price is required",
                                      })}
                                    />
                                  </div>

                                  <div
                                  // className="d-flex gap-3 my-2"
                                  >
                                    <label>Description</label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter advance description"
                                      {...register(`dynamicMacros.advanced.description`, {
                                        required: "Advance description is required",
                                      })}
                                    />
                                  </div>

                                </div>
                              </Col>

                              <Col md={12} className="my-2">
                                <h5>Standard</h5>
                                <div className="d-flex gap-3 my-2">
                                  <div
                                  //className="d-flex gap-3 my-2"
                                  >
                                    <label>Title</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter standard title"
                                      {...register(`dynamicMacros.standard.title`, {
                                        required: "Standard title is required",
                                      })}
                                    />
                                  </div>

                                  {/* <div
                                  //className="d-flex gap-3 my-2"
                                  >
                                    <label>Price</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter standard price"
                                      {...register(`dynamicMacros.standard.price`, {
                                        required: "Standard price is required",
                                      })}
                                    />
                                  </div> */}

                                  <div
                                  // className="d-flex gap-3 my-2"
                                  >
                                    <label>Description</label>
                                    <textarea
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter standard description"
                                      {...register(`dynamicMacros.standard.description`, {
                                        required: "Standard description is required",
                                      })}
                                    />
                                  </div>
                                </div>
                              </Col>

                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="calculation-macros">
                            <Row>

                              {/* macroActivity */}
                              <Col md={12} className="my-2">
                                <h5>Macro activity</h5>
                                {macroActivityFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label htmlFor={`macroActivity.${index}.label`}>
                                        Macro activity label
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter macro activity"
                                        {...register(`macroActivity.${index}.label`, {
                                          required: "Please enter macro activity",
                                        })}
                                      />
                                      {errors?.macroActivity?.[index]?.label && (
                                        <span className="text-danger">
                                          {errors.macroActivity?.[index]?.label?.message}
                                        </span>
                                      )}

                                    </div>
                                    <div>
                                      <label
                                        htmlFor={`macroActivity.${index}.value`}
                                      >
                                        Macro activity value
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter macro activity"
                                        {...register(
                                          `macroActivity.${index}.value`,
                                          {
                                            required: "Please macro activity value",
                                            min: 1,
                                          }
                                        )}
                                      />
                                      {errors?.macroActivity?.[index]?.value && (
                                        <span className="text-danger">
                                          {errors.macroActivity?.[index]?.value.message}
                                        </span>
                                      )}
                                    </div>


                                    <div>
                                      <label htmlFor={`macroActivity.${index}.multiplier`}>
                                        Macro activity multiplier
                                      </label>
                                      <input
                                        type="number"
                                        step="0.00001"
                                        className="form-control"
                                        placeholder="Enter macro activity multiplier"
                                        {...register(`macroActivity.${index}.multiplier`, {
                                          required: "Please enter macro activity multiplier",
                                        })}
                                      />
                                      {errors?.macroActivity?.[index]?.multiplier && (
                                        <span className="text-danger">
                                          {errors.macroActivity?.[index]?.multiplier?.message}
                                        </span>
                                      )}
                                    </div>


                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeMacroActivity(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button onClick={() => appendMacroActivity("")}>
                                  <MdAdd /> Macro activity
                                </Button>
                              </Col>

                              {/* macroObjective */}
                              <Col md={12} className="my-2">
                                <h5>Macro objective</h5>
                                {macroObjectiveFields.map((item, index) => (
                                  <div
                                    key={item.id}
                                    className="d-flex gap-3 my-2"
                                  >
                                    <div>
                                      <label htmlFor={`macroObjective.${index}.label`}>
                                        Macro objective Label
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter macro objective label"
                                        {...register(`macroObjective.${index}.label`, {
                                          required: "Please enter macro objective label",
                                        })}
                                      />
                                      {errors?.macroObjective?.[index]?.label && (
                                        <span className="text-danger">
                                          {errors.macroObjective?.[index]?.label?.message}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      <label htmlFor={`macroObjective.${index}.value`}>
                                        Macro objective value
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter macro objective value"
                                        {...register(`macroObjective.${index}.value`, {
                                          required: "Please enter macro objective value",
                                        })}
                                      />
                                      {errors?.macroObjective?.[index]?.value && (
                                        <span className="text-danger">
                                          {errors.macroObjective?.[index]?.value?.message}
                                        </span>
                                      )}
                                    </div>
                                    <Button
                                      style={{ height: "40px", marginTop: "28px" }}
                                      variant="danger"
                                      onClick={() => removeMacroObjective(index)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </div>
                                ))}
                                <Button onClick={() => appendMacroObjective("")}>
                                  <MdAdd /> Macro objective
                                </Button>
                              </Col>

                            </Row>
                          </Tab.Pane>


                          <Tab.Pane eventKey="macros-page-setting">
                            <Row>
                              <Col md={6} className="my-2">
                                <h5>First Page</h5>
                                <div className="d-flex gap-3 my-2">
                                  <label>Title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter first page title"
                                    {...register(`macroPageSetting.firstPage.title`, {
                                      required: "First page title is required",
                                    })}
                                  />
                                </div>

                                <div className="d-flex gap-3 my-2">
                                  <label>Sub title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter first page sub title"
                                    {...register(`macroPageSetting.firstPage.subtitle`, {
                                      required: "First page sub title is required",
                                    })}
                                  />
                                </div>


                              </Col>

                              <Col md={6} className="my-2">
                                <h5>Second page</h5>
                                <div className="d-flex gap-3 my-2">
                                  <label>Title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter second page title"
                                    {...register(`macroPageSetting.secondPage.title`, {
                                      required: "Second page title is required",
                                    })}
                                  />
                                </div>

                                <div className="d-flex gap-3 my-2">
                                  <label>Sub title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter second page sub title"
                                    {...register(`macroPageSetting.secondPage.subtitle`, {
                                      required: "Second page sub title is required",
                                    })}
                                  />
                                </div>

                                <div className="d-flex gap-3 my-2">
                                  <label>Macro title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter second page macro title"
                                    {...register(`macroPageSetting.secondPage.macroTitle`, {
                                      required: "Second page macro title is required",
                                    })}
                                  />
                                </div>

                                <div className="d-flex gap-3 my-2">
                                  <label>Formula title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter second page formula title"
                                    {...register(`macroPageSetting.secondPage.formulaTitle`, {
                                      required: "Second page formula title is required",
                                    })}
                                  />
                                </div>

                                <div className="d-flex gap-3 my-2">
                                  <label>Description</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter second page description"
                                    {...register(`macroPageSetting.secondPage.description`, {
                                      required: "Second page description is required",
                                    })}
                                  />
                                </div>

                              </Col>

                            </Row>
                          </Tab.Pane>


                          <Tab.Pane eventKey="email-manage">
                            <Row>
                              <Col md={6} className="my-2">
                                {/* <h5>Admin Email</h5> */}
                                <div className="d-flex gap-3 my-2">
                                  <label>Admin Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter admin email"
                                    {...register(`emailManage.adminEmail`, {
                                      required: "Admin email is required",
                                    })}
                                  />
                                </div>
                              </Col>

                              <Col md={6} className="my-2">
                                {/* <h5>Standard</h5> */}
                                <div className="d-flex gap-3 my-2">
                                  <label>Support Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter standard title"
                                    {...register(`emailManage.supportEmail`, {
                                      required: "Support email is required",
                                    })}
                                  />
                                </div>
                              </Col>

                            </Row>
                          </Tab.Pane>


                        </Tab.Content>
                      </Tab.Container>
                    </Col>
                  </Row>

                  <Button type="submit" className="mt-3" disabled={isUpdating}>
                    Save Settings
                  </Button>
                </div>
              </form>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
};

export default Settings;
